import { useMutation } from '@apollo/client';
import { Switch, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { UPDATE_RIDER_SKIP_INSPECTION } from '../../../graphql/Mutations';

const SkipInspectionToggle = ({ riderId, value, disabled }) => {
  const [isSkipped, setIsSkipped] = useState(Boolean(value));
  const [error, setError] = useState('');

  useEffect(() => {
    setIsSkipped(Boolean(value));
  }, [value]);

  const [updateRider, { loading }] = useMutation(UPDATE_RIDER_SKIP_INSPECTION, {
    errorPolicy: 'all',
    onError() {},
  });

  const handleChange = async (checked) => {
    setError('');
    setIsSkipped(checked);
    const response = await updateRider({
      variables: {
        where: { id: riderId },
        data: { skipPickupInspection: checked },
      },
    });
    if (response?.data?.updateUser?.data?.id) return;
    setIsSkipped(!checked);
    setError(
      response?.errors?.[0]?.message || 'Could not update. Please try again.',
    );
  };

  const getTooltipTitle = () => {
    if (error) return error;
    return isSkipped ? (
      <>
        <strong>On:</strong> this rider can pick up without filling the required
        contents or checklist.
      </>
    ) : (
      <>
        <strong>Off:</strong> this rider has to fill the required contents and
        checklist on pickup.
      </>
    );
  };

  return (
    <Tooltip title={getTooltipTitle()} placement="top">
      <span className="d-flex align-center">
        <Switch
          size="small"
          checked={isSkipped}
          loading={loading}
          disabled={disabled || !riderId}
          onChange={handleChange}
        />
      </span>
    </Tooltip>
  );
};

export default SkipInspectionToggle;
